export default __webpack_public_path__ + "static/media/figma.5f8a7856.svg";